import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { AudioTrackingPostAnalyticsComponent } from './deliverables/audio-tracking-post-analytics/audio-tracking-post-analytics.component';
import { CaptionPostAnalyticsComponent } from './deliverables/caption-post-analytics/caption-post-analytics.component';
import { ContentPostAnalyticsComponent } from './deliverables/content-post-analytics/content-post-analytics.component';
import { CustomPostAnalyticsComponent } from './deliverables/custom-post-analytics/custom-post-analytics.component';
import { DescriptionPostAnalyticsComponent } from './deliverables/description-post-analytics/description-post-analytics.component';
import { HashtagPostAnalyticsComponent } from './deliverables/hashtag-post-analytics/hashtag-post-analytics.component';
import { MentionPostAnalyticsComponent } from './deliverables/mention-post-analytics/mention-post-analytics.component';
import { MessagePostAnalyticsComponent } from './deliverables/message-post-analytics/message-post-analytics.component';
import { ProductPlacementPostAnalyticsComponent } from './deliverables/product-placement/product-placement-post-analytics.component';
import { TalkingPointAiPostAnalyticsComponent } from './deliverables/talking-point-ai-post-analytics/talking-point-ai-post-analytics.component';
import { TalkingPointsPostAnalyticsComponent } from './deliverables/talking-points-post-analytics/talking-points-post-analytics.component';
import { TextTrackingPostAnalyticsComponent } from './deliverables/text-tracking-post-analytics/text-tracking-post-analytics.component';
import { TitlePostAnalyticsComponent } from './deliverables/title-post-analytics/title-post-analytics.component';
import { VisualPostAnalyticsComponent } from './deliverables/visual-post-analytics/visual-post-analytics.component';

@Component({
  imports: [
    NgSwitch,
    NgSwitchCase,
    CaptionPostAnalyticsComponent,
    HashtagPostAnalyticsComponent,
    MentionPostAnalyticsComponent,
    MessagePostAnalyticsComponent,
    DescriptionPostAnalyticsComponent,
    TextTrackingPostAnalyticsComponent,
    TitlePostAnalyticsComponent,
    AudioTrackingPostAnalyticsComponent,
    TalkingPointAiPostAnalyticsComponent,
    TalkingPointsPostAnalyticsComponent,
    ContentPostAnalyticsComponent,
    VisualPostAnalyticsComponent,
    ProductPlacementPostAnalyticsComponent,
    CustomPostAnalyticsComponent,
  ],
  selector: 'app-social-post-details',
  styleUrls: ['./social-post-details.component.scss'],
  templateUrl: './social-post-details.component.html',
})
export class SocialPostDetailsComponent extends DeliverableAnalyticsContentDirective {}
